/*eslint-disable */
import { Box, Divider,Tab, Typography } from "@mui/material";
import FormField from "../common/FormField";
import { lazy, Suspense, useEffect, useMemo, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import ShadowWrapper from "../../utils/Shadow-Wrapper/ShadowWrapper";
import Tabs from "../../../../bmr/components/styled/Tab";
import { dispatch, store } from "../../../../store";
import { BarCodeOption, DateFormat, DecimalPlacesOption, FIELD_TYPE, FileSize, LayoutOption, 
  // MultiUploadOptions,
   TabPresetMap, TABS, TimeFormat, 
   TimeFormatDisplay,
    VisualDisplay } from "../constant/constant";
import { useSelector } from "react-redux";
import LinkedFieldForm from "../shadowForms/LinkedFieldForm";
import { clearLinkedField } from "../../slices/FbProperty";

const ValidationForm = lazy(() => import("../shadowForms/ValidationForm"));
const RadioForm = lazy(() => import("../shadowForms/RadioForm"));
const CalculationForm = lazy(() => import("../shadowForms/CalculationForm"));
const ConditionForm = lazy(() => import("../shadowForms/ConditionForm"));
const DropdownForm = lazy(() => import("../shadowForms/DropdownForm"));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const isActive = value === index;
  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      style={{
        display: isActive ? "block" : "none",
      }}
    >
      <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const FbPropertyTab = ({
  selectedField,
  selectedSection,
  sectionIndex,
  fieldIndex,
}) => {
  const { control, setValue: formSetValue, getValues } = useFormContext();
  const [value, setValue] = useState(0);
  const [configureDecimal, setConfigureDecimal] = useState(false);
  const formulaVariables = useSelector(
    (state) => state.bmrFbProperty.formulaVariables
  );
  const sendingValue= getValues('sections');
  const sectionSchema = useWatch({ control, name: `sections` });
  const selectedFieldProp = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}]`,
  });
  const configureDecimalPlaces = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.decimal_places`,
  });
  //@info using the generic enabled property
  const enabled = useWatch({
    control,
    name: `sections[${sectionIndex}].fields[${fieldIndex}].property`,
  });

  const fieldType =
    sectionSchema[sectionIndex]?.fields[fieldIndex]?.property?.field_type;

  const inputTypes = useSelector((state) => state.bmrFbProperty.inputTypes);
  // const FieldsTypesOption = inputTypes.map((type) => ({ value: type.name, label: type.name })); //@info remove static number from dropdown might need later
  const FieldsTypesOption = inputTypes
  .filter(type => type.id !== 7) // remove Static Number & current time
  .map(type => ({
    value: type.name,
    label: type.name,
  }));


  const fieldVariableDict = useMemo(() => {
    const dict = {};

    sectionSchema?.forEach((section, sectionIndex) => {
      section?.fields.forEach((field, fieldIndex) => {
        const label = `${sectionIndex + 1}.${fieldIndex + 1} ${field.label} (${
          field?.property?.field_type
        })`;
        dict[field.input_uuid] = label;
      });
    });

    return dict;
  }, [sectionSchema]);

  const activeTabs = TabPresetMap[fieldType] || [TABS.GENERAL];
  const visibleTabs = Object.values(TABS)
    .map((tab, index) => ({ label: tab, index }))
    .filter((tab) => activeTabs.includes(tab.label));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(clearLinkedField());
  }, [selectedField]);

  useEffect(() => {
    if (fieldType === FIELD_TYPE.CALCULATION && configureDecimalPlaces) {
      setConfigureDecimal(true);
    }
  }, [configureDecimalPlaces]);

  const handleDecimalSwitch = (e) => {
    if (!e.target.checked) {
      formSetValue(
        `sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.decimal_places`,
        null
      );
    }
    setConfigureDecimal(e.target.checked);
  };

  return (
    <Box className="bg-white rounded-2xl h-full overflow-y-auto border-[0.11rem] border-white">
      <div className="h-[49px] bg-[#E8EFFC] gap-[25px] p-[15px] rounded-tl-[10px] rounded-tr-[10px]">
        <Typography variant="h6" fontWeight="bold" >
          Properties Tab
        </Typography>
      </div>
      <Box className="p-3" key={`property-${selectedSection}-${selectedField}`}>
        <Box>
          <Typography className="text-black p-2 break-all capitalize">
            {sectionIndex + 1}.{fieldIndex + 1} {selectedFieldProp?.label}{" "}
            {/* @info removed +1 because already in index  */}
          </Typography>
          <Divider sx={{ mb: "0.9rem" }} />
          <Box >
            <FormField
            sx={{borderRadius:'0.6rem !important',backgroundColor:'#F0F1F5 !important',color:'#777777'}}
              name={`sections.${sectionIndex}.fields.${fieldIndex}.property.field_layout`}
              inputLabelTop="Input Field Layout"
              placeholder="Select the layout"
              type="select"
              size="small"
              options={LayoutOption}
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
            sx={{borderRadius:'0.6em !important',backgroundColor:'#F0F1F5 !important',color:'#777777'}}
              name={`sections.${sectionIndex}.fields.${fieldIndex}.property.field_type`}
              inputLabelTop="Input field type"
              placeholder="Select the type"
              type="select"
              size="small"
              options={FieldsTypesOption}
            />
            <Divider sx={{ mb: "0.9rem" }} />
          </Box>
          <Box className="">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              {visibleTabs.map((tab) => (
                <Tab
                  key={`tab-${tab.label}`}
                  label={tab?.label}
                  {...a11yProps(tab.index)}
                />
              ))}
            </Tabs>
          </Box>
        </Box>

        <Box>
          {/* General */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.GENERAL)}
          >
            <Box key={`property-${selectedSection}-${selectedField}`}>
              {/* @info removing raise query as data is not fetching from BE */}
              {/* <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.general.raise_query`}
                label="Raise Query"
                type="switch"
                size="small"
                description={
                  "Enabling this will help to raise query for this input field."
                }
              />
              <Divider sx={{ mb: "0.9rem" }} /> */}
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.general.required`}
                label="Required"
                type="switch"
                size="small"
                description={
                  "Defines either a recorded value is necessary to complete the task records"
                }
              />
              <Divider sx={{ mb: "0.9rem" }} />
              {/* @info removed from UI as not getting in preview */}
              {/* <Typography variant="subtitle1" fontWeight="500">
                Display Visual Separator
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                mb={1}
                fontWeight="400"
              >
                Determines display and location of a separator between this field and neighbor.
              </Typography>
              <FormField
                sx={{ borderRadius: '0.6rem !important', backgroundColor: '#F0F1F5 !important', color: '#777777' }}
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.general.display_visuals_line`}
                type="select"
                size="small"
                options={VisualDisplay}
                placeholder="Select"
              /> */}
            </Box>
          </TabPanel>
          
          {/* Note */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.NOTE)}
          >
            <Box key={`property-${selectedSection}-${selectedField}`} sx={{ border: '1px solid #F0F1F5', borderRadius: '0.375rem', padding: '10px' }}>
              <Typography variant="subtitle1" fontWeight="400">
                Notes
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                mb={1}
                fontWeight="400"
              >
                Any note(s) relevant to this field will be shown in the form.
              </Typography>
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.note.message_note`}
                type="textarea"
                placeholder="Add Note"
              />
            </Box>
          </TabPanel>

          {/* Validation */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.VALIDATIONS)}
            className="p-0 m-0"
          >
            <ShadowWrapper
              component={ValidationForm}
              fieldId={selectedField}
              store={store}
            />
          </TabPanel>

          {/* Label */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.LABEL)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.default_value`}
              inputLabelTop="Default Value (if required)"
              type="text"
              placeholder="Enter Default Value"
            />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.restricted_num`}
              label="Restrict Numeric Value"
              type="switch"
              description={"Blocks all the numeric value"}
            />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.restricted_spl_char`}
              label="Restrict Special Character"
              type="switch"
              description={
                "Will not allow any special character in input feild"
              }
            />
          </TabPanel>

          {/*  Create Toggle here */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.TOGGLE)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.toggle.toggle_msg_1`}
              inputLabelTop="Toggle message 1"
              placeholder="Message 1"
              size="small"
              description="Defines the toggled output message; usually 'Done' or 'confirmed', but can be any text"
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.toggle.toggle_msg_2`}
              inputLabelTop="Toggle message 2"
              size="small"
              placeholder="Message 2"
              description="Defines the toggled output message; usually 'Done' or 'confirmed', but can be any text"
            />
            <Divider sx={{ mb: "0.9rem" }} />
            {/* @info not getting from BE */}
            {/* <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.toggle.display_visuals_line`}
              inputLabelTop="Display Visual Seperator"
              type="select"
              size="small"
              placeholder="Select"
              options={VisualDisplay}
              description={
                "Determines display and location of a separator between this field and neighbour."
              }
            />
            <Divider sx={{ mb: "0.9rem" }} /> */}
            {/* <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.toggle.default_msg`}
              inputLabelTop="Default toggle message"
              type="select"
              size="small"
              placeholder="Select"
            />
            <Divider sx={{ mb: "0.9rem" }} /> */}
          </TabPanel>

          {/* Input Radio */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_RADIO)}
          >
            {fieldType === FIELD_TYPE.INPUT_RADIO && (
              
            <ShadowWrapper
              component={RadioForm}
              fieldId={selectedField}
              store={store}
            />          
            )}
          </TabPanel>

          {/* Input Dropdown */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_DROPDOWN)}
          >
            {fieldType === FIELD_TYPE.INPUT_DROPDOWN && (
            <ShadowWrapper
              component={RadioForm}
              fieldId={selectedField}
              store={store}
              control={control}
            />
            )}
          </TabPanel>

          {/* Input Text */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_TEXT)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.default_val`}
              inputLabelTop="Default Value (if required)"
              placeholder="Enter Default Value"
              size="small"
              sx={{
                  marginRight: '0px !important',
                }}
            />

            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start" >
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.restrict_number`}
                type="switch"
                size="small"
                sx={{
                  marginRight: '0px !important',
                }}
              />
              <Box sx={{ marginBottom: '0.9rem' }}>
                <Typography variant="body1" fontWeight="500">Restrict Numeric Value</Typography>
                <Typography variant="subtitle2" fontWeight="400" sx={{ color: '#828282' }}>Blocks all the numeric value</Typography>
              </Box>
            </Box>
                        <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start" >
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.restrict_spl_char`}
                type="switch"
                size="small"
                sx={{
                  marginRight: '0px !important',
                }}
              />
              <Box sx={{ marginBottom: '0.9rem' }}>
                <Typography variant="body1" fontWeight="500">Restrict Special Character</Typography>
                <Typography variant="subtitle2" fontWeight="400" sx={{ color: '#828282' }}>Will not allow any special character in the input field.</Typography>
              </Box>
            </Box>
                        <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start" >
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.restrict_email_validation`}
                type="switch"
                size="small"
                sx={{
                  marginRight: '0px !important',
                }}
              />
              <Box sx={{ marginBottom: '0.9rem' }}>
                <Typography variant="body1" fontWeight="500">Restrict Email Validation</Typography>
                <Typography variant="subtitle2" fontWeight="400" sx={{ color: '#828282' }}>Will check for correct email format that is “abc@email.com”</Typography>

              </Box>
            </Box>
            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start" >
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.max_limit`}
                type="switch"
                size="small"
              />
              <Box sx={{ marginBottom: '0.9rem' }}>
                <Typography variant="body1" fontWeight="500">Maximum Limit</Typography>
                <Typography variant="subtitle2" fontWeight="400" sx={{ color: '#828282' }}>Triggers the validation message above the defined value</Typography>

              </Box>
            </Box>
            {enabled?.input_text?.max_limit &&
              <>
                <Typography variant="subtitle1" fontWeight="400">
                  Maximum Limit
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  The upper limit for the validation range, triggers below
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.max_limit_range`}
                  size="small"
                  placeholder="Enter maximum limit value"
                />
              </>
            }
            <Divider sx={{ mb: "0.9rem" }} />
            <Box display="flex" alignItems="flex-start" >
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.min_limit`}
                type="switch"
                size="small"
              
              />
              <Box sx={{ marginBottom: '0.9rem' }}>
                <Typography variant="body1" fontWeight="500">Minimum Limit</Typography>
                <Typography variant="subtitle2" fontWeight="400" sx={{ color: '#828282' }}>Triggers the validation message below the defined value</Typography>

              </Box>
            </Box>
            {enabled?.input_text?.min_limit &&
              <>
                <Typography variant="subtitle1" fontWeight="400">
                  Minimum Limit
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  The lower limit for the validation range, triggers above.
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_text.min_limit_range`}
                  size="small"
                  placeholder="Enter minimum limit value"
                />
              </>
            }
          </TabPanel>

          {/* Input Number */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_NUMBER)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.default_val`}
              inputLabelTop="Default Value (if required)"
              placeholder="Enter Default Value"
              size="small"
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.measurement_unit`}
              inputLabelTop="Measurement Unit (if required)"
              placeholder="Enter Measurement Unit"
              size="small"
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.positive_number`}
              label="Only Positive Number"
              type="switch"
              size="small"
              description={
                "Blocks negative values, message configurable in Validation "
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.whole_number`}
              label="Only Whole Numbers"
              type="switch"
              size="small"
              description={
                "Will only allow any positive number that does not include a decimal part "
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.restrict_text`}
              label="Restrict Text Character"
              type="switch"
              size="small"
              description={
                "will only allow numeric values, and no characters are allowed. "
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.decimal_notation`}
              label="Decimal Notation"
              type="switch"
              size="small"
              description={
                "Field value will be displayed using field-specific decimal configuration"
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />
             {enabled?.input_number?.decimal_notation && (<>
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.decimal_notation_places`}
              inputLabelTop="Decimal Places"
              placeholder="Select"
              type="select"
              options={DecimalPlacesOption}
            />
            <Divider sx={{ mb: "0.9rem" }} />
            </>)
            }
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.scientific_notation`}
              label="Scientific Notation"
              type="switch"
              size="small"
              description={
                "If enabled, the field value will be displayed using scientific notation"
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />
            {enabled?.input_number?.scientific_notation && (<>
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.scientific_exponent_notation`}
                inputLabelTop="Exponent"
                placeholder="Select"
                type="select"
                options={DecimalPlacesOption}
              />
              <Divider sx={{ mb: "0.9rem" }} />
            </>)
            }
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.max_limit`}
              label="Maximum Limit"
              type="switch"
              size="small"
             description="Triggers the validation message above the defined value"
            />
            {enabled?.input_number?.max_limit &&
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.max_limit_range`}
                inputLabelTop="Maximum Limit Value"
                placeholder="Enter Maximum Limit"
                description="Triggers the validation message above the defined value"
              />
            }
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.min_limit`}
              label="Minimum Limit"
              type="switch"
              size="small"
              description="Triggers the validation message below the defined value"              
            />
            {enabled?.input_number?.min_limit && 
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_number.min_limit_range`}
              inputLabelTop="Minimum Limit Value"
              placeholder="Enter Minimum Limit"
              description="Triggers the validation message below the defined value"
            />
            }
          </TabPanel>

          {/* Input email */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_EMAIL)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_email.email_allowed`}
              label="Valid email format "
              type="switch"
              size="small"
              // description="Blocks all other file type"
            />
          </TabPanel>

          {/* Input Current Time */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.INPUT_CURRENT_TIME
            )}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_current_time.time_format`}
              inputLabelTop="Time Format"
              type="select"
              options={TimeFormat}
              placeholder={"Select"}
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_current_time.time_display_format`}
              inputLabelTop="Time Display Format"
              type="select"
              options={TimeFormatDisplay}
              placeholder={"Select"}
            />
          </TabPanel>

          {/* Input Date */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.INPUT_DATE)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date.date_display_format`}
              inputLabelTop="Date Display Format"
              type="select"
              options={DateFormat}
              placeholder={"Select"}
            />
          </TabPanel>

          {/* Input Date and Time */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.INPUT_DATE_AND_TIME
            )}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.time_format`}
              inputLabelTop="Time Format"
              type="select"
              options={TimeFormat}
              placeholder={"Select"}
            />
            <Divider sx={{ mb: "0.9rem" }} />
            {/* <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.time_display_format`}
              inputLabelTop="Time Display Format"
              type="select"
              options={TimeFormatDisplay}
              placeholder={"Select"}
            /> */}
            {/* <Divider sx={{ mb: "0.9rem" }} /> */}
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.input_date_and_time.date_display_format`}
              inputLabelTop="Date Display Format"
              type="select"
              options={DateFormat}
              placeholder={"Select"}
            />
          </TabPanel>

          {/* Linked Field */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.LINKED_FIELD)}
          >
            {fieldType === FIELD_TYPE.LINKED_FIELD && (
              <ShadowWrapper
                component={LinkedFieldForm}
                fieldId={selectedField}
                store={store}
              />
            )}
          </TabPanel>

          {/* Hyperlink */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.HYPERLINK)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.hyperlink.name`}
              inputLabelTop="Name"
              placeholder={"Enter Name"}
              size="small"
              description={"The displayed text of the URI in the eBR / form"}
            />
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              size="small"
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.hyperlink.url`}
              inputLabelTop="URL"
              placeholder={"Enter URL"}
              description={
                "The URI of the hyperlinked location (e.g. https://www.google.com)"
              }
            />
          </TabPanel>

          {/* BarCode */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.BARCODE)}
          >
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.barcode.format`}
              inputLabelTop="Barcode Format"
              type="select"
              options={BarCodeOption}
              size="small"
              placeholder={"Select"}
              description={"Defines the type of barcode to output."}
            />
          </TabPanel>

          {/* File upload */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.FILE_UPLOAD)}
          >
             <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.allow_pdf_file_only`}
              label="Allow only .pdf file"
              type="switch"
              size="small"
              description="Blocks all other file typee."
            />
             <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.allow_other_file_format`}
              label="Allow only JPEG, PNG, and WebP format"
              type="switch"
              size="small"
              description="Blocks all other file type."
            />
          
             <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.allow_multi_upload`}
              label="Allow Multi Upload"
              type="switch"
              size="small"
              description="Enables you to upload multiple files"
            />
            {/* {enabled?.file_upload?.allow_multi_upload &&
              <>
                <Divider sx={{ mb: "0.9rem" }} />
                <Typography variant="subtitle1" fontWeight="400">
                  Limit Multi Upload
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  Set a limit on how much the user can upload.
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.allow_multi_upload_limit`}
                  size="small"
                  type="select"
                  options={MultiUploadOptions}
                  placeholder="Select"
                />
              </>
            } */}
             <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.size_per_file`}
              inputLabelTop="Size per file"
              placeholder="Enter size"
               type="number"
              description={
                "Will restrict all the files whose size is larger than the mentioned file size."
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.file_upload.file_size_unit`}
              inputLabelTop="File Size Measurements Unit"
              placeholder="Select"
              type="select"
              options={FileSize}
            />
            <Divider sx={{ mb: "0.5rem" }} />
          </TabPanel>

          {/* Image upload */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.IMAGE_UPLOAD)}
          >
                <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.allow_jpg_only`}
              label="Allow only JPEG image"
              type="switch"
              size="small"
              description="Restricts all other image types except JPEG"
            />
            {/* @info no need of dimension */}
            {/* {enabled?.file_upload?.allow_jpg_only &&
              <>
                <Divider sx={{ mb: "0.9rem" }} />
                <Typography variant="subtitle1" fontWeight="400">
                  Image Dimension
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  Mention width and height of the image.
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.image_dimension`}
                    size="small"
                    placeholder="Width"
                  />
                  <Typography sx={{ fontWeight: '700' }}>x</Typography>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.image_dimension`}
                    size="small"
                    placeholder="Height"
                  />
                </Box>
              </>
            } */}
                <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.allow_other_format`}
              label="Allow other formats like PNG, WebP"
              type="switch"
              size="small"
              description="Do not restrict other image formats"
            />
             
            {/* {enabled?.file_upload?.allow_other_format &&
              <>
                <Divider sx={{ mb: "0.9rem" }} />
                <Typography variant="subtitle1" fontWeight="400">
                  Image Dimension
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  Mention width and height of the image.
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.image_dimension`}
                    size="small"
                    placeholder="Width"
                  />
                  <Typography sx={{ fontWeight: '700' }}>x</Typography>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.image_dimension`}
                    size="small"
                    placeholder="Height"
                  />
                </Box>
                      </>
            } */}
                <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.allow_multi_upload`}
              label="Allow Multi Upload"
              type="switch"
              size="small"
              description="Enables you to upload multiple images"
            />
            {/* {enabled?.image_upload?.allow_multi_upload &&
              <>
                <Divider sx={{ mb: "0.9rem" }} />
                <Typography variant="subtitle1" fontWeight="400">
                  Limit Multi Upload
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={1}
                  fontWeight="400"
                >
                  Set a limit on how much the user can upload.
                </Typography>
                <FormField
                  name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.multi_upload_limit`}
                  size="small"
                  type="select"
                  options={MultiUploadOptions}
                  placeholder="Select"
                />
              </>
            } */}
            <Divider sx={{ mb: "0.9rem" }} />
            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.size_per_file`}
              inputLabelTop="Size per file"
              placeholder="Enter size"
              type="number"
              description={
                "Will restrict all the images whose size is larger than the mentioned file size."
              }
            />
            <Divider sx={{ mb: "0.9rem" }} />

            <FormField
              name={`sections[${sectionIndex}].fields[${fieldIndex}].property.image_upload.file_size_unit`}
              inputLabelTop="Image Size Measurements Unit"
              placeholder="Select"
              type="select"
              options={FileSize}
            />
            <Divider sx={{ mb: "0.9rem" }} />
          </TabPanel>

          {/* Calculation  */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.CALCULATION)}
          >
            <Box sx={{ mt: 2 }}>
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.formula`}
                inputLabelTop="Formula"
                placeholder="$Value1 + $Value2"
              />
              <Divider sx={{ mb: 1 }}></Divider>
              <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.unit_of_measurement`}
                inputLabelTop="Unit of measurement (if required)"
                placeholder={"Enter measurement unit"}
              />
              <Divider sx={{ mb: 1 }}></Divider>

              <FormField
                sx={{ mb: 0 }}
                type="switch"
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.display_formula`}
                label="Display Formula"
                description="Determines display of the parsed formula in the eBR / form"
              />
              <Divider sx={{ mb: 1 }}></Divider>

{/* @info removed as not getting in preivew */}
              {/* <FormField
                name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.configure_decimal`}
                type="switch"
                label="Configure Number of Decimal Places"
                // checked={configureDecimal}
                // onChange={(e) => handleDecimalSwitch(e)}
                description="If enabled the field value will be displayed using field-specific decimal configuration"
              />
              <Divider sx={{ mb: 1 }}></Divider>
                 {enabled?.calculation?.configure_decimal &&(
                <>
                  <FormField
                    name={`sections[${sectionIndex}].fields[${fieldIndex}].property.calculation.decimal_places`}
                    inputLabelTop="Decimal Places"
                    type="select"
                    options={DecimalPlacesOption}
                    placeholder={"Select"}
                  />
                  <Divider sx={{ mb: 1 }}></Divider>
                </>
              )} */}
              {formulaVariables?.length > 0 && (
                <>
                  <Typography sx={{ mb: 1 }}>Linked Fields</Typography>
                  {formulaVariables.map((item) => {
                    if (!item.name) {
                      return "NA";
                    }
                    return (
                      <Typography
                        sx={{
                          bgcolor: "lightgray",
                          p: "2px",
                          pl: "5px",
                          mb: 1,
                          borderRadius: "5px",
                        }}
                        key={item.linked_field_uuid}
                      >
                        {item.name}: {fieldVariableDict[item.linked_field_uuid]}{" "}
                      </Typography>
                    );
                  })}
                </>
              )}
            </Box>
          </TabPanel>

          {/* Formula Variable  */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex(
              (t) => t.label === TABS.FORMULA_VARIABLES
            )}
          >
            {fieldType === FIELD_TYPE.CALCULATION && (
            <ShadowWrapper
              component={CalculationForm}
              fieldId={selectedField}
              store={store}
              getValues={sendingValue}
            />
            )}
          </TabPanel>

          {/* Conditional */}
          <TabPanel
            value={value}
            index={visibleTabs.findIndex((t) => t.label === TABS.CONDITION)}
          >
            {[FIELD_TYPE.INPUT_DROPDOWN, FIELD_TYPE.INPUT_RADIO,FIELD_TYPE.TOGGLE].includes(fieldType) && (

            <ShadowWrapper
              component={ConditionForm}
              fieldId={selectedField}
              store={store}
              getValues={sendingValue}
            />
            )}
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
};
export default FbPropertyTab;
